import styles from "../../styles/_containers/_management/cubes.module.scss";
import { useAppointmentTerminology } from "../../hooks/useAppointmentTerminology";

const Cubes = ({
  numberOfClients = 0,
  appointmentsThisMonth = 0,
  appointmentsToday = 0,
}) => {
  const terminology = useAppointmentTerminology();
  return (
    <div className={styles.container}>
      <h2>פעילות היומן</h2>
      <div className={styles.cubes}>
        <div className={styles.cube}>
          <h3>{appointmentsToday}</h3>
          <hr />
          <p>{terminology.todayLabel}</p>
        </div>

        <div className={styles.cube}>
          <h3>{appointmentsThisMonth}</h3>
          <hr />
          <p>{terminology.monthLabel}</p>
        </div>

        <div className={styles.cube}>
          <h3>{numberOfClients}</h3>
          <hr />
          <p>לקוחות</p>
        </div>
      </div>
    </div>
  );
};

export default Cubes;
